import {environment} from '../../config/environment';
import {api} from '../../shared/utils';

const baseUrl = environment.apiBaseURLClients;

const buildQuery = (params = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value == null || value === '') return;
        query.set(key, value);
    });
    return query.toString();
};

export const getFinanceiroDashboard = () => api.get(`${baseUrl}/financeiro/dashboard`);

// app-faturamento: envelope {success, message, data, error}; a página começa em 1.
export const listFinanceiroFaturas = (params = {}) => {
    const query = buildQuery(params);
    return api.get(`${baseUrl}/financeiro/faturas${query ? `?${query}` : ''}`);
};

export const getFatura = (faturaId) => api.get(`${baseUrl}/financeiro/faturas/${encodeURIComponent(faturaId)}`);

// Link curto (5 minutos) para o PDF: pedido a cada clique, nunca guardado.
export const getFaturaPdf = (faturaId) => api.get(`${baseUrl}/financeiro/faturas/${encodeURIComponent(faturaId)}/pdf`);

// app-financeiro: sem envelope, a lista pura das cobranças da fatura, em camelCase.
export const listCobrancasDaFatura = (faturaId) => api.get(`${baseUrl}/financeiro/cobrancas?${buildQuery({fatura_id: faturaId})}`);
